<div class="row">
    <div class="col-12">
        <div class="input-wrapper bottom-10">
            <ValidatedRadioButtonGroup [label]="'Select one if you want us to send you information in an accessible format:'"
                                       [options]="optionaccessibility"
                                       [selectedValue]="accessibilityValue"
                                       (onValueChange)="onAccessibilityChanges($event)"
                                       [radioGroupName]="'Langformat'">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p>
                Please call us at 1-855-771-9286 (TTY: 711) if you need information in an accessible format other than what’s listed above. We’re here 24 hours a day, 7 days a week.
            </p>
        </div>
    </div>
</div>